import { render } from "./GlobalLoader.vue?vue&type=template&id=24e97190&scoped=true&ts=true"
import script from "./GlobalLoader.vue?vue&type=script&lang=ts"
export * from "./GlobalLoader.vue?vue&type=script&lang=ts"

import "./GlobalLoader.vue?vue&type=style&index=0&id=24e97190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e97190"]])

export default __exports__